<template>
  <FilePondComponent
    ref="pond"
    name="filepond"
    :allow-multiple="true"
    :files="pondFiles"
    :accepted-file-types="acceptedFileTypes"
    :label-idle="labelIdle"
    :server="server"
    @processfiles="handleAllUploads"
  />
</template>

<script setup>
 /* eslint-disable */ 
import { ref } from 'vue'
import { useSessionStore } from '@/stores/session'
import api from '@/services/api'

// Props and Emits
const props = defineProps({ eventId: String })
const emit = defineEmits(['refreshGallery'])

const session = useSessionStore()

// FilePond setup
import * as FilePond from 'vue-filepond'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'

import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'

const FilePondComponent = FilePond.default(FilePondPluginImagePreview, FilePondPluginFileValidateType)

const pond = ref(null)
const pondFiles = ref([])

const acceptedFileTypes = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif',
  'image/svg+xml'
]

const labelIdle = 'Drop your images here, or <span class="filepond--label-action">Browse</span> to add photos to this album.'

// ✅ Use FilePond's `server.process` instead of @addfile
const server = {
  process: (fieldName, file, metadata, load, error, progress, abort) => {
    const formData = new FormData()
    formData.append('img', file)
    formData.append('event_id', props.eventId)
    formData.append('user_id', session.userId)

    const request = api.AlbumUploadImages(formData, {
      onUploadProgress: (e) => {
        progress(true, e.loaded, e.total)
      }
    })

    request
      .then(res => {
        if (res.data.status === 'ok') {
          load(res.data.filename || file.name)
        } else {
          error('Upload failed')
        }
      })
      .catch(err => {
        console.error('Upload failed:', err)
        error('Upload failed')
      })

    return {
      abort: () => {
        console.log('Upload aborted')
        abort()
      }
    }
  }
}

function handleAllUploads() {
  alert('✅ All images uploaded successfully!')
  pond.value.removeFiles()
  emit('refreshGallery')
}
</script>


<style>

/* Wrap layout with spacing */
.filepond--list {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;               /* space between items */
  padding: 16px !important;
  justify-content: flex-start;
  box-sizing: border-box;
}

/* Each preview item */
.filepond--item {
  width: calc(30% - 12px); /* 4 per row */
  margin: 0 !important;
  padding: 5px !important;
  box-sizing: border-box;
  margin: 10px !important;
}

/* Make previews uniform and avoid overlap */
.filepond--file {
  padding: 0 !important;
  margin: 0 !important;
}

/* Adjust preview panel */
.filepond--panel-root {
  border-radius: 10px;
  margin: 0 !important;
  padding: 0 !important;
  overflow: hidden;
}

/* Drop label (upload area) spacing */
.filepond--drop-label {
  padding: 1rem 0.5rem;
  font-size: 1rem;
}

/* Responsive adjustments */
@media screen and (max-width: 992px) {
  .filepond--item {
    width: calc(30% - 10px); /* 3 per row */
  }
}

@media screen and (max-width: 768px) {
  .filepond--item {
    width: calc(50% - 12px); /* 2 per row */
  }
}

@media screen and (max-width: 480px) {
  .filepond--item {
    width: 100%; /* 1 per row */
  }
}
</style>